import { ProductCategoryDetailPage } from '@/features/product-category/pages/ProductCategoryDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-category/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_category.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductCategoryDetailPage,
})
